import { IpoStringService } from '@ip-only/front-end-library';
import { BehaviorSubject } from 'rxjs';
import { QueryParamService } from '../../shared/util/query-params.service';
import { ConstructionDocumentItem } from '../entities/construction-documents-entities';
import { ConstructionDocumentsService } from '../service/construction-documents.service';
import { updateQueryPath } from './query-param-path-helper';

const selectedFile$ = new BehaviorSubject<ConstructionDocumentItem | null>(
  null,
);

export const setSelectedFile = (file: ConstructionDocumentItem) => {
  selectedFile$.next(file);
};

export const getSelectedFile = () => {
  return selectedFile$.getValue();
};

export const generateSizeString = (
  childCount: number,
  sizeLabel: string,
  translate: IpoStringService,
) => {
  let string = '';
  if (sizeLabel) {
    string = sizeLabel;
    if (childCount > 0) {
      string += ' - ';
    }
  }
  if (childCount > 0) {
    string += `${childCount} ${translate.getText('objects')}`;
  }
  return string;
};

export const handleOnClickConstructionDocumentsItem = (
  item: ConstructionDocumentItem,
  queryParamService: QueryParamService,
  modalService: ConstructionDocumentsService,
) => {
  if (item.type === 'FOLDER') {
    handleOpenFolder(item, queryParamService);
  } else {
    handleDownloadFile(item, modalService);
  }
};

export const handleOpenFolder = (
  folder: ConstructionDocumentItem,
  service: QueryParamService,
) => {
  if (folder.path) {
    updateQueryPath(folder.path, service);
  }
};

export const handleDownloadFile = (
  file: ConstructionDocumentItem,
  modalService: ConstructionDocumentsService,
) => {
  setSelectedFile(file);
  modalService.setModalState(true);
};
